import PropTypes from 'prop-types';

import styles from './ProductDetailReview.module.less';

const ProductDetailReview = ({ productId }) => (
  <div className={styles.container}>
    <div className={styles.reviews} data-bv-product-id={productId} data-bv-show="reviews" />
  </div>
);

ProductDetailReview.propTypes = {
  productId: PropTypes.string,
};

export default ProductDetailReview;
